import { NOOP_VOID, Observable, observe, Scope } from 'wdc-cube'

import type { AlertSeverity } from 'wdc-cube'

export type IDialogScope = Scope & { onClose: () => Promise<void> }

@Observable
export class SignInScope extends Scope {
    @observe() userName?: string
    @observe() userNameError?: string
    @observe() password?: string
    @observe() passwordError?: string
    @observe() rememberMe?: boolean
    @observe() errorMessage?: string

    onSignIn = Scope.ASYNC_ACTION
    onForgotPassword = Scope.ASYNC_ACTION
}

@Observable
export class ResetPasswordScope extends Scope {
    @observe() email?: string
    @observe() emailError?: string

    onResetPassword = Scope.ASYNC_ACTION
    onBackToLogin = Scope.ASYNC_ACTION
}

@Observable
export class AlertScope extends Scope {
    @observe() severity: AlertSeverity = 'info'
    @observe() title?: string
    @observe() message?: string

    onClose = Scope.ASYNC_ACTION
}

@Observable
export class BodyScope extends Scope {
    // NOOP
}

@Observable
export class MainScope extends Scope {
    @observe() authenticated = false
    @observe() toolbar?: Scope | null
    @observe() body?: Scope | null
    @observe() dialog?: IDialogScope
    @observe() alert?: AlertScope
    @observe() drawerOpen = false
    @observe() pjEnabled = true
    @observe() pfEnabled = true
    @observe() serasaEnabled = true
    @observe() serasaHistoryEnabled = true
    @observe() serproEnabled = true
    @observe() grupoEnabled = true
    @observe() analiseEnabled = true
    @observe() monitoramentoEnabled = true
    @observe() borderoEnabled = true

    notify: (severity: AlertSeverity, message: string, duration: number) => void = NOOP_VOID

    onSignOut = Scope.ASYNC_ACTION
    onToggleComplianceMode = Scope.ASYNC_ACTION
    onProfile = Scope.ASYNC_ACTION
    onHome = Scope.ASYNC_ACTION
    onPJ = Scope.ASYNC_ACTION
    onPF = Scope.ASYNC_ACTION
    onSerasa = Scope.ASYNC_ACTION
    onSerasaHistory = Scope.ASYNC_ACTION
    onSerpro = Scope.ASYNC_ACTION
    onDrawerToggle = Scope.ASYNC_ACTION
    onGrupo = Scope.ASYNC_ACTION
    onAnalise = Scope.ASYNC_ACTION
    onMonitoramento = Scope.ASYNC_ACTION
    onBordero = Scope.ASYNC_ACTION
}
